import { IconModule } from './../icon/icon.module';
import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { StatusModule } from "../status/status.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectComponent } from "./select.component";

@NgModule({
	declarations: [SelectComponent],
	imports: [
		CommonModule,
		FormsModule,
		LabelModule,
		HelpTextModule,
		StatusModule,
		IconModule
	],
	exports: [SelectComponent]
})
export class SelectModule { }
